<template>
  <div class="wrap">
    <div class="container">
      <div class="top-row">
        <i class="el-icon-document"></i>
        <a
          href="https://school.jinritemai.com/doudian/web/article/103279?from=shop_settled"
          target="_blank"
          >入驻手册</a
        >
      </div>
      <div class="step-row">
        <el-steps
          :active="activeStep"
          simple
          finish-status="success"
          style="background-color: #fff"
        >
          <el-step title="01.填写主体信息"></el-step>
          <el-step title="02.填写店铺信息"></el-step>
          <el-step title="03.资质审核"></el-step>
          <el-step title="04.账户验证"></el-step>
        </el-steps>
      </div>

      <el-container class="main">
        <el-main class="left-form">
          <stepOne
            ref="stepOne"
            v-if="activeStep == 0"
            @onSuccess="handleOne"
            @onTips="handleTips"
          />
          <stepTwo
            ref="stepTwo"
            v-if="activeStep == 1"
            @onSuccess="handleTwo"
            @onTips="handleTips"
          />
        </el-main>
        <el-aside width="306px" style="height: 100%">
          <div class="right-tips">
            <div class="tips-content">
              <tips :showItem="currentItem" />
            </div>
            <div class="help">
              <div>
                <span>是否有帮助?</span>
                <i class="icon el-icon-circle-check"></i>
                <i class="icon el-icon-circle-close"></i>
              </div>
            </div>
          </div>
        </el-aside>
      </el-container>

      <div class="bottom">
        <button class="btn" @click="handlePrev">上一步</button>
        <button class="btn next" @click="handleNext">
          {{ activeStep == 0 ? "下一步" : "提交审核" }}
        </button>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="show" width="30%">
      <span>离开当前页面，所填信息将不会保留，请再次确认是否返回上一步</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$router.go(-1)">确 定</el-button>
        <el-button @click="show = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import stepOne from "./stepOne.vue";
import stepTwo from "./stepTwo.vue";
import tips from "./tips.vue";
export default {
  components: {
    stepOne,
    stepTwo,
    tips,
  },
  data() {
    return {
      activeStep: 0,
      form: { mobile: this.$route.query.mobile, type: this.$route.query.type },
      currentItem: "licenseImg",
      show: false,
    };
  },
  methods: {
    handlePrev() {
      if (this.activeStep == 0) {
        this.show = true;
      } else {
        this.activeStep--;
      }
    },
    handleNext() {
      if (this.activeStep == 0) {
        this.$refs.stepOne.handleSubmit();
      } else if (this.activeStep == 1) {
        this.$refs.stepTwo.handleSubmit();
      }
    },
    handleTips(item) {
      this.currentItem = item;
    },
    handleOne(data) {
      this.form = { ...this.form, ...data };
      this.activeStep++;
      this.currentItem = "shopType";
    },
    handleTwo(data) {
      this.form = { ...this.form, ...data };
      console.log(data);
      let nowTime = new Date();
      this.$router.push({
        path: "/simulation/doudian/step/stepThree",
        query: {
          data: JSON.stringify(this.form),
          time: nowTime,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  position: relative;
  width: 100%;
  height: 100vh;
  background: rgb(246, 246, 250);
  .top-row {
    padding: 16px 0;
    color: #1966ff;
    text-align: right;
  }
  .step-row {
    padding: 13px 40px;
    background-color: #fff;
    margin-bottom: 16px;
    border-radius: 4px;
    ::v-deep .el-step.is-simple {
      .el-step__title {
        font-size: 14px;
      }
      .el-step__arrow {
        position: relative;
        &::before {
          display: none;
        }
        &::after {
          position: absolute;
          top: 8px;
          left: 6px;
          display: block;
          width: 90%;
          content: "";
          height: 4px;
          background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIyIiBoZWlnaHQ9IjQiIHJ4PSIxIiBmaWxsPSIjZWRlZWYwIi8+PC9zdmc+)
            repeat-x;
          transform: none;
        }
      }
    }
  }
  .main {
    height: calc(100vh - 51px - 72px - 16px - 16px - 64px);
    .left-form {
      height: 100%;
      border-radius: 4px;
      background: #fff;
      padding: 0 24px;
      overflow-y: auto;
    }
    .right-tips {
      padding: 14px 16px 16px;
      max-height: 100%;
      border-top: 4px solid #1966ff;
      border-radius: 4px;
      background: #fff;
      overflow: auto;
      .help {
        margin-top: 16px;
        padding-top: 16px;
        border-top: 1px solid #eeeff0;
        text-align: left;
        font-size: 12px;
        line-height: 18px;
        color: #565960;
        .icon {
          margin-left: 10px;
          font-size: 14px;
          color: #898b8f;
          cursor: pointer;
          &:hover {
            color: #4784ff;
          }
        }
      }
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    width: 1200px;
    height: 64px;
    line-height: 64px;
    background-color: #fff;
    .btn {
      padding: 6px 16px;
      border-radius: 4px;
      color: #12141a;
      background: #fff;
      border: 1px solid #dcdde0;
      transition: all 0.3s ease;
      &:hover {
        color: #1966ff;
        border-color: #1966ff;
      }
      &.next {
        margin-left: 8px;
        color: #fff;
        background: #1966ff;
        border: 1px solid transparent;
        &:hover {
          background: #4784ff;
        }
      }
    }
  }
}
</style>